import React from 'react';

/**
 * Mobile tab button component for filtering leads.
 */
export const MobileTabButton = ({ children, active, onClick }) => (
    <button
        onClick={onClick}
        className={`flex-shrink-0 px-3 py-1.5 text-xs font-medium rounded-full transition-colors border ${active ? 'bg-stone-800 text-white border-stone-800' : 'bg-white text-stone-600 border-stone-200'
            }`}
    >
        {children}
    </button>
);

export default MobileTabButton;
